import { useGetBankAccountsList } from '@/hooks/requests/useBankAccounts';
import { BankAccountListSortBy } from '@/types/bankAccounts';
import { Box, Card, Typography } from '@mui/material';
import { useBrandingTheme } from '@/hooks/stores/useBrandingTheme';
import { abbreviateAmount } from '@/utils/currency';
import { useNavigate } from 'react-router-dom';
import { SVLoader, SVButton } from '@/components/core';

export default function AdvisorDashboardTopAccounts() {
  const navigate = useNavigate();
  const { brandingTheme } = useBrandingTheme();

  const { accounts, accountsIsPending } = useGetBankAccountsList({
    page: 0,
    records_per_page: 10,
    sort_by: BankAccountListSortBy.AVAILABLE_BALANCE_DESCENDING,
  });

  if (accountsIsPending) {
    return (
      <Card>
        <SVLoader />
      </Card>
    );
  }

  if (!accounts) {
    return null;
  }

  const topBalance =
    accounts.length >= 1 ? Number(accounts[0].availableBalance.value) : 0;

  return (
    <Card>
      <Typography variant="h5" mb={2}>
        Your Top Accounts
      </Typography>
      {accounts.map(account => {
        const { uuid, primaryOwner, accountTypeStr, availableBalance } =
          account;
        const numberAvailableBalance = Number(availableBalance.value);

        return (
          <Box
            key={uuid}
            sx={{ display: 'flex', flexDirection: 'row', gap: 2, mb: 1 }}>
            <Box sx={{ flex: 1 }}>
              <Typography>
                <Typography fontWeight="bold" component="span">
                  {primaryOwner.profile.firstName}{' '}
                  {primaryOwner.profile.lastName}:
                </Typography>{' '}
                {accountTypeStr}
              </Typography>
              <Box
                sx={{
                  height: 20,
                  width: numberAvailableBalance / topBalance,
                  background: brandingTheme.primaryColor,
                }}
              />
            </Box>
            <Typography
              sx={{
                alignSelf: 'flex-end',
                fontWeight: 'bold',
                fontSize: '20px',
                lineHeight: '20px',
              }}>
              ${abbreviateAmount(Number(numberAvailableBalance))}
            </Typography>
          </Box>
        );
      })}
      <SVButton sx={{ mt: 2 }} variant="text" onClick={() => navigate('')}>
        View All
      </SVButton>
    </Card>
  );
}
